import { StyleSheet } from 'aphrodite';
import { white } from '../../../web/styles/colors';
import { CssSelectors } from '../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	container: {
		boxSizing: 'border-box',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'flex-start',
		minHeight: '100vh',
		width: '100%',
	},
	header: {
		alignItems: 'center',
		background: white,
		paddingTop: 20,
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		textAlign: 'center',
		...CssSelectors.allChildren(
			{
				fontSize: 16,
				margin: '14px 0 0 0',
			},
			':not(:first-child)'
		),
	},
	heading: {
		margin: 0,
	},
	surveyContent: {
		display: 'flex',
		flexDirection: 'column',
		width: '100%',
	},
	unavailable: {
		margin: '20px 0',
		textAlign: 'center',
	},
	logo: {
		width: '100%',
		maxWidth: 200,
	},
	introContent: {
		maxWidth: 600,
		fontSize: 12,
	},
});
